@if (profileData(); as data) {
  @if (data.qrCode) {
    <div class="loyalty-block" (click)="openQrModal(data.qrCode)">
      <div class="loyalty-block__left">
        <div class="loyalty-block__status text-b2-s-500 text-md-b1-m-500">{{ data.segmentName }}</div>
        @if (data.bonusBalance) {
          <div class="loyalty-block__bonus">
            <sd-bonus-widget [amount]="data.bonusBalance.value"></sd-bonus-widget>
          </div>
        }
      </div>
      <div class="loyalty-block__right">
        <qrcode
          [qrdata]="data.qrCode"
          [width]="isTablet() ? 132 : 120"
          [errorCorrectionLevel]="'M'"
          [colorLight]="'#e6e6e6'"
        ></qrcode>
        @if (useNewQrEnableFlag$ | async) {
          <sd-update-qr-button></sd-update-qr-button>
        }
      </div>
    </div>
  }
}
